"use client";

import {
  type VenueAdsConversionEntry,
  clearVenueAdsConversions,
  setVenueAdsConversions,
} from "@punchup/analytics";
import { useEffect } from "react";

/**
 * Publishes VenueAnalyticsLoader's server-validated {tagId,
 * purchaseLabel} entries onto `window.__punchupVenueAdsConversions` for
 * `trackVenuePurchaseConversion` (in `@punchup/analytics`) to read at
 * checkout purchase-complete (D14). Mirrors VenueAnalyticsScripts's
 * `__punchupVenueGa4Ids` publish pattern.
 *
 * Receives already-validated entries as props — never
 * dangerouslySetInnerHTML — since they only ever populate a JS object
 * global, not an inline script. The window-global key literal lives only in
 * `@punchup/analytics` (its reader), via the set/clear pair. Clearing on
 * unmount means a client-side navigation to a page without this bridge (or
 * to a different venue) can't leave a stale/wrong venue's tags behind to
 * fire against. Renders nothing.
 */
export default function PublishVenueAdsConversions({
  entries,
}: {
  entries: VenueAdsConversionEntry[];
}) {
  useEffect(() => {
    setVenueAdsConversions(entries);
    return clearVenueAdsConversions;
  }, [entries]);

  return null;
}
